import { PayloadAction, createSelector, createSlice } from '@reduxjs/toolkit';
import { RootState } from '..';
import { WidgetID } from '../../models/widget.model';
import {
  GridConfig,
  GridConfigUserData,
  GridConfigDictionary,
  GridGroupActionPayload,
} from '../../models/grid-config.model';

// identifier
export const GRID_CONFIG_SLICE_ID = 'gridConfig';

// default state
const initialState: GridConfigUserData = {
  key: -1,
  data: {},
};

//slice
const gridConfigSlice = createSlice({
  name: GRID_CONFIG_SLICE_ID,
  initialState,
  reducers: {
    setUserDataKey: (state: GridConfigUserData, action: PayloadAction<number>) => {
      state.key = action.payload;
    },
    loadConfig: (state: GridConfigUserData, action: PayloadAction<GridConfigDictionary>) => {
      state.data = {};
      Object.keys(action.payload).forEach((key) => {
        state.data[key] = action.payload[key];
      });
    },
    setGridConfig: (
      state: GridConfigUserData,
      action: PayloadAction<{ id: WidgetID; data: GridConfig }>
    ) => {
      state.data[action.payload.id] = action.payload.data;
    },
    resetGridConfig: (state: GridConfigUserData, action: PayloadAction<WidgetID>) => {
      delete state.data[action.payload];
    },
    setGridGroup: (state: GridConfigUserData, action: PayloadAction<GridGroupActionPayload>) => {
      state.data[action.payload.id].group = action.payload.group;
    },
    clearGridGroup: (state: GridConfigUserData, action: PayloadAction<WidgetID>) => {
      state.data[action.payload].group = [];
    },
  },
});

//selectors

export const selectGridConfigById = createSelector(
  [
    (state: RootState): GridConfigUserData => state.gridConfig,
    (_: RootState, widgetId: WidgetID) => widgetId,
  ],
  (gridConfig, gridId) => {
    return gridConfig.data[gridId] ?? {};
  }
);

export const selectConfigKey = (state: RootState) => state.gridConfig.key;

export const selectGridConfig = (state: RootState) => state.gridConfig.data;

//actions
export const {
  setGridConfig,
  loadConfig,
  setGridGroup,
  clearGridGroup,
  setUserDataKey: setGridConfigKey,
  resetGridConfig,
} = gridConfigSlice.actions;

//reducer
export default gridConfigSlice;
